import { render, staticRenderFns } from "./EditAppConfig.vue?vue&type=template&id=507a232a&"
import script from "./EditAppConfig.vue?vue&type=script&lang=js&"
export * from "./EditAppConfig.vue?vue&type=script&lang=js&"
import style0 from "./EditAppConfig.vue?vue&type=style&index=0&id=507a232a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports